import React from 'react';
import {Flex} from "../ui";
import CurrencyFormat from 'react-currency-format';
import {Modal} from "../ServiciosMaestros/componentGeneral";
export default function AlertDialog(props) {
  function handleClose() {
    props.closeModal();
  }
  return(
      <Modal open={props.visible} close={handleClose} tipo={"info"}>

          <Flex className={"dialog-title-wrap py-3"}
                direction={"colunm"}
          >
              <h5>
                  <i className={"dialog-title-icon " + props.icono + " mr-3"}
                  />
                  {props.titulo}
              </h5>
          </Flex>
          <p className={"text-center mb-0  pb-2 mb-2 dialog-subtitle"}><b>{props.subtitulo}</b></p>
            <div className={"wc dialog-content-scroll"}>
                {
                    props.data.map((item, key) =>
                        <Flex className={'pb-1 wc'} key={key} >
                            <div className={"col-6 text-right text-color-black"}>
                                <small className={"mb-0"}><b>{item.llave}:</b></small>
                            </div>
                            <div className={'col-6 px-2 '}>
                                {item.entidad === 'total' || item.entidad === 'segundoTotal' || item.entidad === 'tercerTotal'?
                                    <CurrencyFormat value={item.valor} displayType={'text'} thousandSeparator={true} prefix={'$'}/>
                                    :<p className={"mb-0"}>{item.valor}</p>}
                            </div>
                        </Flex>
                    )
                }
            </div>

      </Modal>
  );
}
